import BaseCRUDService from '../BaseCRUDService';

class EquipmentTypeService extends BaseCRUDService {
  getBaseURL = () => {
    return '~/api/product/equipmentType';
  };
}

export default new EquipmentTypeService();
